<p>open-awarded-restricted-tender works!</p>
